import { Plan, ShopManager } from '@benzinga/shop-manager';
import { Select } from 'antd';
import styled from 'styled-components';
import { SessionContext } from '@benzinga/session-context';
import React from 'react';
import { PlanConfig } from './types';

interface PlansListProps {
  product: string;
  plans: PlanConfig[];
  handlePlanSelection: (plan: Plan) => void;
  selectedPlan: Plan | undefined;
}

export const RenderUpsellPlans: React.FC<PlansListProps> = props => {
  const session = React.useContext(SessionContext);
  const shopManager = session.getManager(ShopManager);
  const [plans, setPlans] = React.useState<Plan[]>();

  const fetchPlans = React.useCallback(async () => {
    const product = await shopManager.getProduct(props.product);
    if (product.err) return;
    const localPlans = props.plans && new Set(props.plans.map(plan => plan.slug));
    setPlans(product.ok.plans.filter(plan => localPlans.has(plan.slug)));
  }, [props.plans, props.product, shopManager]);

  const plansOptions = React.useMemo(
    () =>
      plans?.map(plan => {
        const priceRegex = /\(\$?\d+\.?\d*\)/;
        const label = `${plan.name} ${priceRegex.test(plan.name) ? '' : `($${plan.price})`}`;
        return {
          label,
          value: plan.name,
        };
      }),
    [plans],
  );

  React.useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);
  return (
    <>
      <label>Please Select a Plan</label>
      <PlanSelect
        onChange={value => {
          const selectedPlan = plans?.find(plan => plan.name === value);
          if (selectedPlan) {
            props.handlePlanSelection(selectedPlan);
          }
        }}
        options={plansOptions}
        placeholder="Select a plan"
        value={props.selectedPlan?.name}
      />
    </>
  );
};
const PlanSelect = styled(Select)`
  height: max-content;
  min-height: 40px !important;
  padding: 0px;
`;
